export default __webpack_public_path__ + "static/media/samplesec.319079b0.png";